export class FormatterPipeArg {
  public value: any;
  public isProperty: boolean;

  constructor(value: any, isProperty: boolean = false) {
    this.value = value;
    this.isProperty = isProperty;
  }
}
